import { render } from "./TheContacts.vue?vue&type=template&id=7d644ea6&scoped=true"
import script from "./TheContacts.vue?vue&type=script&lang=js"
export * from "./TheContacts.vue?vue&type=script&lang=js"

import "./TheContacts.vue?vue&type=style&index=0&id=7d644ea6&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d644ea6"]])

export default __exports__